import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { AmlFilterOption } from '@portal-workspace/grow-shared-library';

/** An empty selection reads "All" and means no condition. */
@Component({
  selector: 'aml-multi-filter',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatFormFieldModule, MatSelectModule, MatButtonModule],
  styleUrls: ['./aml-multi-filter.component.scss'],
  template: `
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>{{label}}</mat-label>
      <mat-select multiple placeholder="All" [value]="selected" [attr.aria-label]="label"
        (selectionChange)="selectedChange.emit($event.value)">
        <mat-select-trigger>{{summary()}}</mat-select-trigger>
        <div class="presets">
          <button mat-button type="button" color="primary" (click)="selectAll()">Select all</button>
          <button mat-button type="button" color="primary" (click)="unselectAll()">Unselect all</button>
        </div>
        @for (option of options; track option.value) {
          <mat-option [value]="option.value">{{option.label}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  `,
})
export class AmlMultiFilterComponent<T extends string> {

  @Input({ required: true }) label!: string;
  @Input({ required: true }) options!: AmlFilterOption<T>[];
  @Input() selected: T[] = [];
  @Output() selectedChange = new EventEmitter<T[]>();

  summary(): string {
    if (this.selected.length === 0 || this.selected.length === this.options.length) {
      return 'All';
    }
    if (this.selected.length === 1) {
      return this.options.find(option => option.value === this.selected[0])?.label ?? this.selected[0];
    }
    return `${this.selected.length} selected`;
  }

  selectAll(): void {
    this.selectedChange.emit(this.options.map(option => option.value));
  }

  unselectAll(): void {
    this.selectedChange.emit([]);
  }
}
